var _path, _path2, _path3, _path4, _path5, _g, _defs;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGoogleWithGreenTick = function SvgGoogleWithGreenTick(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.67634 23.0897L7.1828 18.9746C6.86793 18.04 6.69767 17.0401 6.69767 16.0001C6.69767 14.9601 6.86793 13.9603 7.1828 13.0257L1.67633 8.91059C0.602348 11.0444 0 13.4502 0 16.0001C0 18.5501 0.60235 20.9558 1.67634 23.0897Z",
    fill: "#FBBC05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18355 13.0256C8.45403 9.25449 12.0789 6.54546 16.3728 6.54546C18.6798 6.54546 20.7635 7.34545 22.4008 8.65455L27.1635 4C24.2612 1.52727 20.5403 0 16.3728 0C9.903 0 4.34013 3.61934 1.67708 8.91046L7.18355 13.0256Z",
    fill: "#EA4335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.67361 23.0849C4.3358 28.3785 9.89995 31.9998 16.3716 31.9998C24.5576 31.9998 31.9995 26.1816 31.9995 15.9998C31.9995 15.0543 31.8507 14.0362 31.6274 13.0907H16.3716V19.2725H25.153C24.3344 23.1998 20.9111 25.4543 16.3716 25.4543C12.0726 25.4543 8.44428 22.739 7.17784 18.961L1.67361 23.0849Z",
    fill: "#34A853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3715 13.0907H31.6274C31.8506 14.0362 31.9994 15.0543 31.9994 15.9998C31.9994 21.2147 30.0472 25.2849 27.0427 28.015L21.8151 24.0598C23.5244 23.0056 24.7137 21.3799 25.1529 19.2725H16.3715V13.0907Z",
    fill: "#4285F4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6109 26.5216C23.6109 22.9953 26.4154 20.1367 29.875 20.1367C31.6142 20.1367 33.1878 20.8592 34.3228 22.0257L24.7962 30.2599C24.6264 30.0206 24.4725 29.7689 24.336 29.5062C23.8731 28.6155 23.6109 27.5998 23.6109 26.5216Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.6805 26.6665C24.6805 23.721 27.0353 21.3332 29.9402 21.3332C32.8451 21.3332 35.2 23.721 35.2 26.6665C35.2 29.6121 32.8451 31.9999 29.9402 31.9999C27.0353 31.9999 24.6805 29.6121 24.6805 26.6665Z",
    fill: "#54AB31"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4301 24.8692C32.6168 25.0585 32.6168 25.3655 32.4301 25.5548L29.5611 28.4639C29.3744 28.6533 29.0716 28.6533 28.8849 28.4639L27.4504 27.0094C27.2637 26.82 27.2637 26.513 27.4504 26.3237C27.6371 26.1344 27.9399 26.1344 28.1266 26.3237L29.223 27.4354L31.7538 24.8692C31.9406 24.6798 32.2433 24.6798 32.4301 24.8692Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.5195,
    height: 10.6667,
    fill: "white",
    transform: "translate(24.6805 21.3332)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogleWithGreenTick, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google-with-green-tick.c1acbd59.svg";
export { ForwardRef as ReactComponent };